import { render, staticRenderFns } from "./TutorSearch.vue?vue&type=template&id=c37225ce"
import script from "./TutorSearch.vue?vue&type=script&lang=ts"
export * from "./TutorSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports